<template>
<div class="order-wrapper">
    <portal target-el="#filter">
      <PrimaryFilter
        :menuOptions="menuOptions"
        :selectedCategory="seletedCategory"
        :enableSearchPopup="enableSearchPopup"
        :searchParameters="searchParameters"
        :preSearchedParams="searchedParams"
        :buttonsList="buttonsList"
        :isUploading="isUploading"
        :rejectDownload="rejectCount"
        @searchByParameter="searchByParams"
        @exportData="exportData"
        @bulkUpload="bulkUpload"
        @rejectDownload="rejectDownload"
        @add="openAddSlider"
        searchText="Search" />
    </portal>
    <div class="flex-container page-filter">
      <div class="flex-item">
        <FilterWrapper
          :values="filterTags"
          @openSliderLeft="openSlideleft = !openSlideleft">
        </FilterWrapper>
      </div>
    </div>
    <div class="top slideleft_drawer" :class="{ openSlideleft: openSlideleft }">
      <div class="slideleft_content"
        v-infinite-scroll="loadMore"
        infinite-scroll-disabled="loadCheck"
        infinite-scroll-throttle-delay="400"
        infinite-scroll-distance="10">
        <MdmHeader
          :headers="sectionHeaders"
          :hasColumnPicker="true"
          :noCheckbox="true"
          :maxDisplayColumn="maxDisplayColumn"/>
        <div v-if="isLoading" class="paymentloader"></div>
        <div v-else-if="list.length === 0" class="emptydiv">
          <div class="paymentempty"></div>
          <div class="emptytext">No data found!</div>
        </div>
        <MdmRow
          v-else
          v-for="(port,index) in userList"
          :key="index"
          :data="port"
          :headers="sectionHeaders"
          :showEdit="showEdit"
          v-on:edit="openEditForm(port)" />
      </div>
      <div class="slideleft_menu">
        <SecFilter
          v-if="!isLoading"
          :selectedFilters="filterConstant"
          :filters="roles"
          @search="searchApply"
          @updateOption="updateOption"
          @reset="resetApply"
          @clearDate = "clearDate"/>
      </div>
    </div>

    <div class="slideleft_drawer">
      <div class="slideleft_content">
        <div class="content pt-20" v-if="showForm">
          <Drawer
            :visible.sync="showForm"
            direction="rtl"
            size="700px"
            :modal="true"
            :withHeader="false"
            :append-to-body="true"
            class="default-drawer">
            <Link :underline="false" class="nav-close" @click="closeSlider">
              <svgicon name="cancelwhite" width="12" height="12" :original="true" />
            </Link>
            <Form
              v-if="!isLoadingFormConstants"
              :formConstant="addFormConstants"
              :data="selectedRow"
              :isEdit="isEditForm"
              sectionTitle="Users"
              :hasUserDepotPermission="hasUserDepotPermission"
              v-on:cancel="closeSlider"
              v-on:add="add"
              v-on:update="update"/>
          </Drawer>
        </div>
      </div>
    </div>
</div>
</template>

<script>
/* eslint-disable import/no-extraneous-dependencies */
import MdmHeader from '@common/components/HeaderV2';
import MdmRow from '@common/components/mdm-v2/Row';
import PrimaryFilter from '@/components/common/PrimaryFilter';
import SharedMdmV2 from '@/components/mixins/SharedMdmV2';
import Form from '@common/components/mdm-v2/Form';
import SecFilter from '@common/components/SecFilter';
import SecFilterMixin from '@common/mixins/SecFilterMixin';
import FilterWrapper from '@common/components/FilterWrapperV2';
import { filters } from '@/constants/mdm-v2/users';

export default {
  components: {
    PrimaryFilter,
    MdmHeader,
    MdmRow,
    Form,
    SecFilter,
    FilterWrapper,
  },
  mixins: [SharedMdmV2, SecFilterMixin],
  data() {
    return {
      openSlideleft: false,
      transactionIds: [],
      skipEditPermission: true,
      overrideDefaultSearchParms: true,
      filterConstant: [],
      filters: [],
      defaultValues: [],
      roles: [],
      searchedParams: {},
    };
  },
  async created() {
    this.loadSearchFromSession();
    await this.loadFormConstants();
    this.setDefaults();
    this.loadFilterFromSession();
    this.loadMore();
  },
  computed: {
    hasUserDepotPermission() {
      return this.$hasPermission('update_user');
    },
    userList() {
      return this.list && this.list.map((value) => {
        const obj = {
          name: value.name,
          account_role: this.roles.find(role => role.id === value.primary_role).name,
          mobile: value.mobile,
          email: value.email,
          depot_ids: this.getDepot(value),
          status: (value.status === 1) ? 'Active' : 'Inactive',
        };
        return { ...value, ...obj };
      });
    },
  },
  methods: {
    getDepot(value) {
      if (value.depot_ids.length) {
        return `${this.depots.find(_depot => value.depot_ids[0].id === _depot.id).name} ${value.depot_ids.length > 1 ? `+ ${value.depot_ids.length - 1}` : ''}`;
      }
      return '';
    },
    loadFilterFromSession() {
      this.loadFilters();
      this.applyFilters();
      this.filterParams = this.constructFilterPayload();
    },
    loadSearchFromSession() {
      const sessionSearchParamsJSON =
        localStorage.getItem(`${this.$route.name}-search-popup`) || '{}';
      const sessionSearchParams = JSON.parse(sessionSearchParamsJSON);
      this.searchedParams = { ...this.searchedParams, ...sessionSearchParams };
    },
    saveSearchToSession() {
      const sessionSearch = JSON.stringify(this.searchedParams);
      localStorage.setItem(`${this.$route.name}-search-popup`, sessionSearch);
    },
    searchByParams(params) {
      this.searchByParameter(params);
      this.saveSearchToSession();
    },
    constructUserPayload(_data) {
      const data = _data;
      data.status = data.status ? 1 : 0;
      data.depot_ids =
        (data.depot_ids && data.depot_ids.map(item => item._id)) ||
        [];
      return data;
    },
    setDefaults() {
      [this.defaultValues.roles] = this.allRolesList;
      [this.defaultValues.depots] = this.allDepotList;
      [this.defaultValues.status] = this.allStatusList;
    },
    constructConstantForFilter() {
      this.filterConstant = [
        [
          {
            type: 'List',
            category: filters.depots,
            default: this.defaultValues.depots,
            selected: this.defaultValues.depots,
            list: this.allDepotList,
            idLabel: 'id',
            queryParamString: 'depots',
            optional: true,
          },
          {
            type: 'List',
            category: filters.role,
            default: this.defaultValues.roles,
            selected: this.defaultValues.roles,
            list: this.allRolesList,
            idLabel: 'id',
            queryParamString: 'role_id',
            optional: true,
          },
          {
            type: 'List',
            category: filters.status,
            default: this.defaultValues.status,
            selected: this.defaultValues.status,
            list: this.allStatusList,
            idLabel: 'id',
            queryParamString: 'status',
            optional: true,
          },
        ],
      ];
    },
    resetApply() {
      this.resetAll();
      this.searchApply();
    },
    searchApply() {
      this.applyFilters();
      this.openSlideleft = false;
      const filter = this.constructFilterPayload();
      this.searchByFilter(filter);
    },
    async loadFormConstants() {
      this.isLoadingFormConstants = true;
      this.roles = (await this.$store.dispatch('mdmV2/getRoles')).data;
      this.depots = (await this.$store.dispatch('mdmV2/getDepots')).data;
      this.allRolesList = [
        { id: -1, name: 'All Roles' },
        ...this.roles.map(val => ({ id: val.id, name: val.name })),
      ];
      this.allDepotList = [
        { id: -1, name: 'All Depots' },
        ...this.depots.map(val => ({ id: val.id, name: val.name })),
      ];
      this.allStatusList = [
        { id: -1, name: 'All Status' },
        { id: 1, name: 'Active' },
        { id: 0, name: 'Inactive' },
      ];
      const index = this.addFormConstants.findIndex(
        val => val.paramKey === 'depot_ids',
      );
      this.addFormConstants[index].options = this.depots;
      const roleIndex = this.addFormConstants.findIndex(
        val => val.paramKey === 'role_id',
      );
      this.addFormConstants[roleIndex].options = this.roles;
      this.isLoadingFormConstants = false;
    },
    async openEditForm(data) {
      const userData = await this.$store.dispatch('mdmV2/show', {
        section: `transporter/${this.currentSection}`,
        id: data.id,
      });
      userData.role_id = this.roles.find(role =>
        role.id.toString() === userData.primary_role.toString()).id;
      userData.depot_ids.forEach((userDepot) => {
        this.depots.forEach((depot) => {
          if (depot.id === userDepot.id) {
            userDepot._id = depot.id;
            userDepot.name = depot.name;
          }
        });
      });
      this.selectedRow = userData;
      this.isEditForm = true;
      this.openSlider();
    },
  },
};
</script>